/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'sarsaparilla';

function LotteryWinnerPrompt(props) {
    const {
        orderId,
        permitName,
        permitLocation,
        recareaName,
        divisionID,
        startDate,
        confirmDate,
        permitTypeName,
        isAccepting,
        isDeclining,
        handleLotteryAccept,
        handleLotteryDecline,
    } = props;

    return (
        <div className="permit-aside permit-lottery-winner-prompt">
            <div className="rec-aside-header">
                <div>Order: {orderId}</div>
            </div>
            <div className="rec-aside-body">
                <div className="right-rail-card">
                    <h3 className="permit-text-half-size">{permitName} - Permit</h3>
                    {recareaName && <div className="grayed">{recareaName}</div>}
                    {permitLocation && <div className="grayed">{permitLocation}</div>}
                    <br />
                    <div id="permit-winner-start-date">
                        <span>
                            <b>Start Date</b>: {startDate}
                        </span>
                    </div>
                    <div id="permit-winner-division">
                        <span>
                            <b>Unit</b>: {divisionID}
                        </span>
                    </div>
                    {permitTypeName && (
                        <div id="permit-winner-permit-type">
                            <span>
                                <b>Permit Type</b>: {permitTypeName}
                            </span>
                        </div>
                    )}
                    <div id="permit-winner-confirm-date">
                        <span>
                            <b>Confirm Decision By</b>: {confirmDate}
                        </span>
                    </div>
                    <br />
                    <Button
                        id="permit-winner-accept-button"
                        className="mb-2"
                        aria-label="accept-and-register"
                        onClick={handleLotteryAccept}
                        isDisabled={isAccepting}
                        size="lg"
                        shouldFitContainer
                    >
                        {isAccepting ? 'Loading...' : 'Accept & Register'}
                    </Button>
                    <Button
                        id="permit-winner-decline-button"
                        className="mb-2"
                        aria-label="decline-reservation"
                        onClick={handleLotteryDecline}
                        isDisabled={isDeclining}
                        size="lg"
                        shouldFitContainer
                    >
                        {isDeclining ? 'Loading...' : 'Decline Reservation'}
                    </Button>
                </div>
            </div>
        </div>
    );
}

LotteryWinnerPrompt.propTypes = {
    isAccepting: PropTypes.bool,
    isDeclining: PropTypes.bool,
    handleLotteryAccept: PropTypes.func,
    handleLotteryDecline: PropTypes.func,
    orderId: PropTypes.string,
    permitName: PropTypes.string,
    permitLocation: PropTypes.string,
    recareaName: PropTypes.string,
    divisionID: PropTypes.string,
    startDate: PropTypes.string,
    confirmDate: PropTypes.string,
    selectedLotteryPreference: PropTypes.shape({
        division_id: PropTypes.string,
        group_max_size: PropTypes.number,
        length_of_stay: PropTypes.number,
        preferred_date: PropTypes.string,
    }),
    permitTypeName: PropTypes.string,
};
export default LotteryWinnerPrompt;
